/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import back from '../assets/images/back.svg'
import { Card } from 'primereact/card'
import { TabView, TabPanel } from 'primereact/tabview'
import { Editor } from 'primereact/editor'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { userActions } from '../_actions'
import { useHistory } from 'react-router-dom'

export default function ManageContentComponent({ content, updateContent, getContent }) {
  const [contentData, setContentData] = useState(content)
  const saveContent = () => {
    if (contentData?.title.trim().length > 0 && contentData?.subTitle1.trim().length > 0 && contentData?.subTitle2.trim().length > 0) {
      updateContent(contentData)
    }
  }
  useEffect(() => {
    getContent()
  }, [getContent])
  useEffect(() => {
    setContentData(content)
    const updatedBy = 'updatedBy'
    setContentData(content => ({ ...content, [updatedBy]: userActions.getCurrentUser() }))
  }, [content])
  function onGenralDisclosure(event) {
    const genralDisclosure = 'genralDisclosure'
    setContentData(contentData => ({ ...contentData, [genralDisclosure]: event.htmlValue }))
  }
  function onContentChange(event) {
    const content = 'content'
    setContentData(contentData => ({ ...contentData, [content]: event.htmlValue }))
  }
  function onBulletinBoard(event) {
    const bulletinBoard = 'bulletinBoard'
    setContentData(contentData => ({ ...contentData, [bulletinBoard]: event.htmlValue }))
  }
  function onIntroductionChange(event) {
    const introduction = 'introduction'
    setContentData(contentData => ({ ...contentData, [introduction]: event.htmlValue }))
  }
  function onChange(e) {
    const { name, value } = e.target
    setContentData(contentData => ({ ...contentData, [name]: value }))
  }
  const history = useHistory()
  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase managecontent">
          <div className="p-col-12 titleSec">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
            <h4 className="display_1 m-b-0">Manage Content</h4>
          </div>
          <div className="p-col-12">
            <TabView renderActiveOnly={false}>
              <TabPanel header="General Disclosure" leftIcon="pi pi-key">
                <Editor name='genralDisclosure' style={{ height: '320px' }} value={contentData?.genralDisclosure} onTextChange={onGenralDisclosure} />
              </TabPanel>
              <TabPanel header="Introduction" leftIcon="pi pi-desktop">
                <Editor style={{ height: '320px' }} value={contentData?.introduction} onTextChange={onIntroductionChange} />  </TabPanel>
              <TabPanel header="Home Page" leftIcon="pi pi-home">
                <div className="p-col-12">
                  <div className="p-col-6">
                    <span className="inputHolder">
                      <label className="inputHolder--label">Title  <sup className="inputHolder--required">*</sup></label>
                      <InputText name='title' className="inputHolder--inputBox" value={contentData?.title} onChange={onChange} />
                    </span>
                  </div>
                  <div className="p-col-6">
                    <span className="inputHolder">
                      <label className="inputHolder--label">Sub Title 1  <sup className="inputHolder--required">*</sup></label>
                      <InputText name='subTitle1' className="inputHolder--inputBox" value={contentData?.subTitle1} onChange={onChange} />
                    </span>
                  </div>

                  <div className="p-col-6">
                    <span className="inputHolder">
                      <label className="inputHolder--label">Sub Title 2  <sup className="inputHolder--required">*</sup></label>
                      <InputText name='subTitle2' className="inputHolder--inputBox" value={contentData?.subTitle2} onChange={onChange} />
                    </span>
                  </div>
                </div>
                <Editor style={{ height: '320px' }} value={contentData?.content} onTextChange={onContentChange} />
              </TabPanel>
              <TabPanel header="Bulletin Board" leftIcon="pi pi-list">
                <Editor style={{ height: '320px' }} value={contentData?.bulletinBoard} onTextChange={onBulletinBoard} />
              </TabPanel>
            </TabView>
          </div>
          <div className="flex m-t-10 p-justify-end">
            <Button label="Update" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={() => saveContent()} />
          </div>
        </Card>
      </div>
    </div>
  )
}
